module.exports = __webpack_public_path__ + "assets/img/f8e57fdb78967a7caf7d740dc070d3cb.png";